// Switch between Stores list / Stores map
var storesSwitches = function(){

    var storeSwitch     = $('.tv-js-storesSwitch');
    var storeSwitchIsOn = 'tv-storesSwitch--on';
    var elementToSwitch = $('.tv-storesSwitch-element');
    var elementToClick = $('.tv-storesList-countryName');


    storeSwitch.on('click', function(e){
        e.preventDefault();
        storeSwitch.removeClass(storeSwitchIsOn);
        elementToSwitch.removeClass(storeSwitchIsOn);
        var elementToDisplay = $(this).attr('href');
        $(elementToDisplay).addClass(storeSwitchIsOn);
        $(this).addClass(storeSwitchIsOn);
    });

    elementToClick.on('click', function(e){
       $(this).closest('.tv-storesList-country').find('.list-container').toggleClass('hide');
       $(this).toggleClass('open');
    });

}

// For a11y only
var storesLocationsNavigation = function() {
  if (!$('.tv-js-store-item')) return;

  $(document).on('keyup', '.tv-js-store-item', function(e) {
    e.preventDefault();

    if (e.key === 'Enter' || e.keyCode === 13) {
      $(this).next('.js-list-container').toggleClass('hide');
      $(this).next('.js-list-container').hasClass('hide') ? $(this).attr('aria-expanded', 'false') : $(this).attr('aria-expanded', 'true');
    }
  })
}

$(document).ready(function(){
    storesSwitches();
    storesLocationsNavigation();
});
